module.exports = __webpack_public_path__ + "static/media/18.47166384.png";